import ApiClient from "../../api-client/api-client";
import AppContext from "../../app/app-context";
import BaseComponent from "../../app/base-component";

import Popup from "../../app/popup/popup";
import Table from "../../app/table/table";

import "./tenant-domain-popup.css";

class TenantDomainPopup extends BaseComponent {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.state = {
      tennantDomain: {
        domain: props.tenant.tenantSettings.domain,
      },
    };
  }

  onInputChange(e) {
    let key = e.target.name;
    var value = e.target.value;

    this.setState((state) => ({
      tennantDomain: {
        ...state.tennantDomain,
        [key]: value,
      },
    }));
  }

  updateTenantDomain() {
    let translations = this.context.translations;
    let apiClient = new ApiClient(this.context);

    apiClient
      .call(
        "PUT",
        `/v1/TenantSettings/${this.props.tenant.tenantSettings.id}/Domain`,
        this.state.tennantDomain
      )
      .then((result) => {
        if (result.ok) {
          this.props.onCommit && this.props.onCommit();

          this.setState({
            dialog: {
              className: 'tenantDnsPopup',
              title: "DNS settings",
              message: "Voer onderstaande DNS records in voor het domein:",
              content: <Table
                mapping={{
                  name: {
                    label: translations.general_name,
                  },
                  type: {
                    label: translations.general_type,
                  },
                  value: {
                    label: translations.general_value,
                  },
                }}
                entries={result.json}
              />,
            },
          });
        } else {
          throw result;
        }
      });
  }

  render() {
    let translations = this.context.translations;
    return (
      // TODO: I18n
      <Popup
        className={"tenantDomainPopup"}
        title={translations.tenant_domain_title}
        actions={[
          {
            label: translations.general_update,
            handler: this.updateTenantDomain.bind(this),
            submit: true,
          },
        ]}
        onDismiss={this.props.onDismiss}
      >
        <div>
          <div className="popup-section">
            <div className="popup-column">
              <div className="popup-inputContainer">
                <h2>{translations.tenant_domain_name}</h2>
                <input
                  name="domain"
                  value={this.state.tennantDomain.domain}
                  onChange={this.onInputChange.bind(this)}
                ></input>
              </div>
            </div>
          </div>
        </div>
      </Popup>
    );
  }
}

export default TenantDomainPopup;
